import React from "react";
import TextInputLabel from "@components/Ui/TextInputLabel/index.js";
import "./style.scss";

const ContactDetailsForm = ({
                                showDisplayName,
                                firstName,
                                lastName,
                                purchaseEmail,
                                emailError,
                                onFirstNameChange,
                                onLastNameChange,
                                onEmailChange,
                                className = "contact-details-form",
                                idPrefix = "contact",
                                required = false,
                            }) => (
                                <div className={className}>
                                    {showDisplayName && (
                                    <>
                                        <h2 className="contact-details-form__title">Contact details</h2>
                                        <TextInputLabel
                                            id={`${idPrefix}-first-name`}
                                            type="text"
                                            labelName="First Name"
                                            placeholder="Enter first name"
                                            value={firstName}
                                            onChange={onFirstNameChange}
                                            required={required}
                />
                                        <TextInputLabel
                                            id={`${idPrefix}-last-name`}
                                            type="text"
                                            labelName="Last Name"
                                            placeholder="Enter last name"
                                            value={lastName}
                                            onChange={onLastNameChange}
                                            required={required}
                />
                                    </>
        )}
                                    <TextInputLabel
                                        id={`${idPrefix}-purchase-email`}
                                        type="email"
                                        labelName="Email Address"
                                        placeholder="Enter email address"
                                        value={purchaseEmail}
                                        onChange={onEmailChange}
                                        isValueErrored={!!emailError}
                                        required={required}
        />
                                    {emailError && (
                                    <p className={`${className}__email-error`}>{emailError}</p>
        )}
                                </div>
);

export default ContactDetailsForm;

